import React from "react";
import { Link } from "react-router-dom";

const L = "underline font-bold text-[#E05624]";

export default function ConsentTick({ lang, checked, onChange, testid, kind = "booking" }) {
  const what = kind === "booking" ? (lang === "hi" ? "इस बुकिंग" : "this booking") : (lang === "hi" ? "इस पूछताछ" : "this enquiry");
  const terms = <Link to="/terms" target="_blank" className={L} data-testid={`${testid}-terms-link`}>{lang === "hi" ? "नियम (Terms)" : "Terms"}</Link>;
  const privacy = <Link to="/privacy" target="_blank" className={L} data-testid={`${testid}-privacy-link`}>{lang === "hi" ? "प्राइवेसी पॉलिसी" : "Privacy Policy"}</Link>;
  return (
    <label className="flex items-start gap-3 cursor-pointer">
      <input data-testid={testid} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-1 h-5 w-5 shrink-0 accent-[#E05624]" />
      <span className="text-sm text-[#121316]">
        {lang === "hi"
          ? <>मैं CHELA के {terms} और {privacy} से सहमत हूँ, और CHELA को {what} के बारे में WhatsApp/फ़ोन पर संपर्क करने की अनुमति देता/देती हूँ। *</>
          : <>I agree to CHELA's {terms} and {privacy}, and allow CHELA to contact me on WhatsApp/phone about {what}. *</>}
      </span>
    </label>
  );
}
